import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6rjkukddmmni7ck8u4g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer id="contact" className="bg-gray-900 mx-2 md:mx-10 mb-4 md:mb-10 rounded-3xl">
      <div className="max-w-7xl mx-auto px-5 md:px-12 py-10 md:py-16">
        <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-10 md:mb-16">
          <div>
            <h3 className="text-2xl md:text-4xl font-light text-white mb-3 md:mb-4">Stay Updated</h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Get notified about new beat releases, exclusive deals, and studio availability.
            </p>
            <form 
              id="newsletter-form"
              data-readdy-form
              onSubmit={handleNewsletterSubmit}
              className="space-y-4"
            >
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-transparent border-b border-gray-700 text-white placeholder-gray-500 py-3 focus:border-red-500 focus:outline-none transition-colors"
              />
              {submitStatus === 'success' && (
                <p className="text-green-400 text-sm">Successfully subscribed!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-400 text-sm">Something went wrong. Please try again.</p>
              )}
            </form>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-400 mb-4 tracking-wider">EXPLORE</h4>
            <ul className="space-y-3">
              <li><a href="#beats" className="text-white hover:text-red-400 transition-colors underline cursor-pointer">All Beats</a></li>
              <li><a href="#booking" className="text-white hover:text-red-400 transition-colors underline cursor-pointer">Booking</a></li>
              <li><Link to="/licensing" className="text-white hover:text-red-400 transition-colors underline cursor-pointer">Licensing</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-400 mb-4 tracking-wider">GET IN TOUCH</h4>
            <div className="space-y-3 text-white">
              <p className="hover:text-red-400 transition-colors cursor-pointer">+1 (571)-699-5343</p>
              <p className="hover:text-red-400 transition-colors cursor-pointer">Text Message Preferably</p>
            </div>
            <h4 className="text-sm font-semibold text-gray-400 mt-6 mb-3 tracking-wider">STUDIO LOCATION</h4>
            <p className="text-gray-400 leading-relaxed">
              Woodbridge, VA 22191
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex gap-6">
            <a href="https://www.instagram.com/officialjaymaximus/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-400 transition-colors underline cursor-pointer">Instagram</a>
          </div>
          
          <div className="text-gray-400 text-sm">
            © 2026 NCMG Studio. All rights reserved.
          </div>

          <div className="flex gap-6">
            <a href="#privacy" className="text-white hover:text-red-400 transition-colors underline cursor-pointer">Privacy Policy</a>
            <a href="#terms" className="text-white hover:text-red-400 transition-colors underline cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}